export default __webpack_public_path__ + "static/media/puff-geosecma-nyhetsbrev_13266697e0ef459b2621e346164c6de2.d0471b8b.png";